import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setApprovalConfiguration } from '../../../../redux/slices/LomavisPostApproval/lomavisPostApproval';
import CustomQuillEditor from '../../../communication/messages/customQuill';
import BasicQuillEditor from '../../../generic/basicQuillEditor';

export const APPROVAL_TEXT_EDITOR_TARGET_PUBLIC_MESSAGE = "public_message";
export const APPROVAL_TEXT_EDITOR_TARGET_PRIVATE_MESSAGE = "private_message";

interface ApprovalQuillTextProps {
  target: string;
}

export const ApprovalQuillText: React.FC<ApprovalQuillTextProps> = ({
  target
}) => {
  const {
    data: { public_message, private_message },
  } = useSelector((state: any) => state.lomavisPostApproval);
  const [quillEditor, setQuillEditor] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    if (quillEditor) {
      quillEditor.off('text-change');

      quillEditor.setContents(
        target === APPROVAL_TEXT_EDITOR_TARGET_PUBLIC_MESSAGE
          ? public_message
          : private_message
      );

      quillEditor.on('text-change', () => {
        dispatch(
          setApprovalConfiguration({
            key: target,
            value: quillEditor.getContents()
          })
        );
      });
    }
  }, [quillEditor]);
  return (
    <BasicQuillEditor
      quillEditor={quillEditor}
      setQuillEditor={setQuillEditor}
      editorStyle={{}}
      readOnly={false}
    />
  );
};
